<template>
		<div class="development">
  <div class="container">
    <h2 class="text-center mb-5">Folgende Proammiersprachen und Frameworks bieten wir an</h2>
    
    <div class="row">
    <TechnologyCard
      img-src="img/flutter-logo.png"
      title="Flutter"
      description="Flutter ist ein Open-Source-Framework von Google für die plattformübergreifende mobile Entwicklung mit hoher Performance und ansprechender UI."
    />
    <TechnologyCard
      img-src="img/django-logo.png"
      title="Django"
      description="Django ist ein skalierbares Python-Framework, das sich durch Sicherheit, Schnelligkeit und einfache Verwaltung von Datenbanken für komplexe Webanwendungen auszeichnet."
    />
    <TechnologyCard
      img-src="img/golang-logo.png"
      title="Golang"
      description="Golang, von Google entwickelt, ist eine effiziente Programmiersprache, ideal für Hochleistungsanwendungen und Netzwerkdienste."
    />
    <TechnologyCard
      img-src="img/react-logo.png"
      title="React"
      description="React ist eine JavaScript-Bibliothek von Facebook, die sich auf die Erstellung von wiederverwendbaren UI-Komponenten für dynamische Webanwendungen konzentriert."
    />
    <TechnologyCard
      img-src="img/angular-logo.png"
      title="Angular"
      description="Angular, von Google entwickelt, ist ein Framework für die Entwicklung von leistungsstarken und skalierbaren Single-Page-Webanwendungen."
    />
    <TechnologyCard
      img-src="img/flask-logo.png"
      title="Flask"
      description="Flask ist ein leichtgewichtiges Python-Framework, das sich für schnelle und einfache Webanwendungen eignet, mit Fokus auf Erweiterbarkeit und Flexibilität."
    />
    <TechnologyCard
      img-src="img/vuejs-logo.png"
      title="Vue.js"
      description="Vue.js ist ein progressives JavaScript-Framework für die Erstellung von modernen, reaktiven Web-Interfaces, das sich durch einfache Integration und Flexibilität auszeichnet."
    />
    <TechnologyCard
      img-src="img/rails-logo.png"
      title="Ruby on Rails"
      description="Ruby on Rails ist ein leistungsfähiges Web-Framework, das den Entwicklungsprozess durch Konventionen und die Nutzung von Ruby vereinfacht."
    />
    </div>
  </div>
</div>
</template>

<script>
import TechnologyCard from '../components/TechnologyCard.vue';

export default {
  name: 'AppDevelopemen',
  components: {
    TechnologyCard
  }
};
</script>

<style>
.development	{
  padding: 80px 0;
}
h2 {
  margin-top: 20px;
}
.row {
  margin-top: 40px;
}
</style>

